import { useEffect, useState } from "react";
import QRCode from "qrcode";

const QrCell = ({ data, field }) => {
  const [qrCode, setQrCode] = useState("");
  const [qrCodeDownload, setQrCodeDownload] = useState("");

  useEffect(() => {
    const GenerateQr = async () => {
      try {
        const qrSvg = await QRCode.toString(data?.value, { type: "svg" });
        setQrCode(qrSvg);

        const qrPng = await QRCode.toDataURL(data?.value, {
          type: "image/png",
          width: 300,
        });
        setQrCodeDownload(qrPng);
      } catch (error) {
        console.error("Error generating QR code:", error);
      }
    };

    if (data?.value) {
      GenerateQr();
    }
  }, [data?.value]);

  if (!data?.value) return null;

  return (
    <div className="flex justify-center flex-col items-center">
      <div
        className="hover:scale-150 transition duration-100 cursor-pointer h-20 w-20"
        dangerouslySetInnerHTML={{ __html: qrCode }}
      />

      {qrCodeDownload && (
        <a
          href={qrCodeDownload}
          download={`QRCode_${field}.png`}
          className="text-blue-500 underline"
        >
          {data.value}
        </a>
      )}
    </div>
  );
};

export default QrCell;
